<template>
  <div>
    <!-- 搜索 -->
    <el-row class="auto-message__search">
      <span>策略类型</span>
      <el-select v-model="searchListTrigger.strategyType" filterable placeholder="请选择">
        <el-option v-for="item in strategyTypeList" :key="item.value" :label="item.name"
          :value="item.value"></el-option>
      </el-select>
      <span>渠道</span>
      <el-select v-model="searchListTrigger.channel" filterable placeholder="请选择">
        <el-option v-for="item in channelList" :key="item.channelId" :label="item.name" :value="item.value">
        </el-option>
      </el-select>
      <span>国家</span>
      <el-select v-model="searchListTrigger.countryCode" filterable placeholder="请选择">
        <el-option v-for="item in countryList" :key="item.countryCode" :label="item.country"
          :value="item.countryCode">
        </el-option>
      </el-select>
      <el-button style="margin-left: 10px" type="success" @click="getAllMessageTrigger(1)">搜索</el-button>
      <el-button style="margin-left: 10px" type="success" @click="updateTriggerMessage(null, 0)">添加</el-button>
      <el-row style="margin-top: 10px">
        <span>策略类型</span>
        <el-select v-model="review.strategyType" filterable placeholder="请选择" style="width: 150px">
          <el-option v-for="item in strategyTypeList" :key="item.value" :label="item.name"
            :value="item.value"></el-option>
        </el-select>
        <span>策略名称</span>
        <el-input v-model="review.triggerName" placeholder="请输入名称" style="width: 200px"></el-input>
        <span>用户rid</span>
        <el-input v-model="review.userRid" type="number" placeholder="请输入rid" style="width: 200px"></el-input>
        <span>主播rid</span>
        <el-input v-model="review.hostRid" type="number" placeholder="请输入rid" style="width: 200px"></el-input>
        <el-button style="margin-left: 20px" @click="reviewQuery">复核</el-button>
      </el-row>
    </el-row>
    <!-- 复核弹窗 -->
    <el-dialog :visible.sync="reviewDialog">
      <el-row class="reviewDialog">
        <el-row class="head">
          <p class="item" v-for="item in reviewList.triggerList" :key="item">
            {{ item }}
          </p>
        </el-row>
        <el-row class="content">{{ reviewList.log }}</el-row>
      </el-row>
    </el-dialog>
    <!-- 表格 -->
    <el-row>
      <el-table border :data="messageListTrigger">
        <el-table-column type="index" label="序号" align="center">
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center">
        </el-table-column>
        <el-table-column prop="name" label="策略名称" align="center">
        </el-table-column>
        <el-table-column label="策略类型" align="center">
          <template slot-scope="scope">
            {{ getName(scope.row.strategyType, strategyTypeList) }}
          </template>
        </el-table-column>
        <el-table-column prop="channel" label="渠道" align="center">
        </el-table-column>
        <el-table-column prop="countryCode" label="国家" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="360">
          <template slot-scope="scope">
            <el-button type="primary" @click="updateTriggerMessage(scope.row, 1)">编辑</el-button>
            <el-button type="success" @click="updateTriggerMessage(scope.row, 2)">复制</el-button>
            <el-button :type="scope.row.valid === 1 ? 'danger' : 'warning'" @click="changeTrigger(scope.row)">{{
              scope.row.valid === 1 ? '下线' : '上线' }}</el-button>
            <el-button type="info" @click="deleteTriggerMessage(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 分页 -->
    <el-row>
      <el-pagination background layout="prev, pager, next" :total="triggerTotalPage" :page-size="pageSize"
        :current-page.sync="triggerCurrentPage" @current-change="guaranteedHandleCurrentChangeTrigger">
      </el-pagination>
    </el-row>
    <!-- 弹出框 -->
    <el-dialog :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="triggerDialog" title="策略触发配置" width="70%">
      <el-form :rules="rules" ref="Form" :model="formTrigger" label-width="120px">
        <el-form-item label="策略类型" label-width="120px" prop="strategyType">
          <el-select v-model="formTrigger.strategyType" filterable placeholder="请选择" style="width: 400px">
            <el-option v-for="item in strategyTypeList" :key="item.value" :label="item.name"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" label-width="120px" prop="name" placeholder="请输入名称" v-if="triggerType !== 1">
          <el-input v-model.trim="formTrigger.name" style="width: 400px"
            v-if="formTrigger.strategyType !== 3"></el-input>
          <el-select v-else v-model="formTrigger.name" style="width: 400px" filterable placeholder="请选择">
            <el-option v-for="(item, index) in mathAllList" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-row>
          <el-form-item label="渠道" label-width="120px" prop="channel"
            v-if="formTrigger.strategyType !== 4 && formTrigger.strategyType !== 5 && formTrigger.strategyType !== 6 && formTrigger.strategyType !== 7 && formTrigger.strategyType !== 8 && formTrigger.strategyType !== 9">
            <el-checkbox v-model="formTrigger.isChannel" style="margin-right: 10px">排除渠道</el-checkbox>
            <el-select v-model="formTrigger.channel" style="width: 400px" filterable multiple collapse-tags
              clearable placeholder="请选择">
              <el-option v-for="item in channelList" :key="item.channelId" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-form-item label="国家" label-width="120px"
          v-if="formTrigger.strategyType !== 4 && formTrigger.strategyType !== 5 && formTrigger.strategyType !== 6 && formTrigger.strategyType !== 7 && formTrigger.strategyType !== 8 && formTrigger.strategyType !== 9">
          <el-checkbox v-model="formTrigger.isCountry" style="margin-right: 10px">排除国家</el-checkbox>
          <el-select v-model="formTrigger.countryCode" filterable multiple collapse-tags clearable placeholder="请选择"
            style="width: 400px">
            <el-option v-for="item in countryList" :key="item.countryCode" :label="item.country"
              :value="item.countryCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户标签" label-width="120px"
          v-if="formTrigger.strategyType == 4 || formTrigger.strategyType == 5 || formTrigger.strategyType == 6 || formTrigger.strategyType == 7 || formTrigger.strategyType == 8 || formTrigger.strategyType == 9">
          <el-select v-model="formTrigger.userSign" filterable multiple collapse-tags clearable placeholder="请选择"
            style="width: 400px">
            <el-option v-for="(item, index) in userList" :key="index" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" label-width="120px">
          <el-input v-model="formTrigger.remark" type="textarea" style="width: 400px" placeholder="请输入内容"
            :autosize="true" :maxlength="400"></el-input>
        </el-form-item>
        <template v-if="formTrigger.strategyType === 1">
          <el-row class="triggerItem">
            <el-row class="day">
              <span class="title">Day: </span>
              <el-input v-model="loginList.day" style="width: 100px"></el-input>
            </el-row>
            <draggable v-model="loginList.items">
              <transition-group>
                <el-row class="contentItem" v-for="(item, index) in loginList.items" :key="index">
                  <span>编号{{ index + 1 }}</span>
                  <el-input v-model="item.delayTime" type="number" style="width: 250px">
                    <template slot="prepend">延迟时间</template>
                    <template slot="append">秒</template>
                  </el-input>
                  <el-select v-model="item.hostSign" placeholder="下发用户组" v-el-select-loadmore="loadMoreUserSigns">
                    <el-option v-for="item in hostSignlist" :key="item.name" :label="item.name" :value="item.name"
                      filterable clearable>
                    </el-option>
                  </el-select>
                  <el-select v-model="loginList.items[index].autoMessageName" placeholder="请选择策略下发内容" filterable
                    clearable>
                    <el-option-group v-for="group in options" :key="group.label" :label="group.label">
                      <el-option v-for="item in group.options" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <div class="close" @click="closeTrigger(index, 1)">X</div>
                </el-row>
              </transition-group>
            </draggable>
            <el-row>
              <el-button @click="addMore(1)">+（添加更多策略内容）</el-button>
            </el-row>
          </el-row>
        </template>
        <template v-else-if="formTrigger.strategyType === 2">
          <el-row class="triggerItem">
            <el-row class="day">
              <span class="title">Day: </span>
              <el-input v-model="vipList.day" style="width: 100px"></el-input>
            </el-row>
            <draggable v-model="vipList.items">
              <transition-group>
                <el-row class="contentItem" v-for="(item, index) in vipList.items" :key="index">
                  <span>编号{{ index + 1 }}</span>
                  <el-input v-model="item.delayTime" type="number" style="width: 250px">
                    <template slot="prepend">延迟时间</template>
                    <template slot="append">秒</template>
                  </el-input>
                  <el-select v-model="item.hostSign" placeholder="下发用户组" @load-more="loadMoreUserSigns">
                    <el-option v-for="item in hostSignlist" :key="item.name" :label="item.name" :value="item.name"
                      filterable clearable>
                    </el-option>
                  </el-select>
                  <el-select v-model="item.autoMessageName" placeholder="请选择策略下发内容">
                    <el-option-group v-for="group in options" :key="group.label" :label="group.label" filterable
                      clearable>
                      <el-option v-for="item in group.options" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-option-group>
                  </el-select>
                  <div class="close" @click="closeTrigger(index, 2)">X</div>
                </el-row>
              </transition-group>
            </draggable>
            <el-row>
              <el-button @click="addMore(2)">+（添加更多策略内容）</el-button>
            </el-row>
          </el-row>
        </template>
        <template v-else-if="formTrigger.strategyType === 3">
          <el-row class="triggerItem">
            <el-row class="contentItem" style="border: none" v-for="(item, index) in matchingList" :key="index">
              <el-input v-model="item.rate" type="number" style="width: 400px">
                <template slot="prepend">{{
                  index === 'mutualFollowRate'
                    ? '互相关注'
                    : index === 'singleFollowRate'
                      ? '单向关注'
                      : '不关注'
                }}后登录触发概率</template>
                <template slot="append">%</template>
              </el-input>
              <el-select v-model="item.autoMessageName" filterable clearable placeholder="请选择策略下发内容">
                <el-option-group v-for="group in options" :key="group.label" :label="group.label">
                  <el-option v-for="item in group.options" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-row>
          </el-row>
        </template>
        <template v-else-if="formTrigger.strategyType === 4 || formTrigger.strategyType === 5">
          <el-row class="triggerItem">
            <div class="otherMessage">
              <div class="items" v-for="(item, index) in otherList" :key="index">
                <div class="delete" @click="() => {
                  otherList.splice(index, 1)
                }">X</div>
                <el-select v-model="item.hostSign" placeholder="请选择主播标签" filterable clearable>
                  <el-option v-for="(item, index) in hostList" :key="index" :label="item.name"
                    :value="item.name"></el-option>
                </el-select>
                <el-input v-model="item.viewPageSecond" type="number" v-if="formTrigger.strategyType == 4"
                  style="width: 250px">
                  <template slot="prepend">查看资料页</template>
                  <template slot="append">秒</template>
                </el-input>
                <el-input v-model="item.hostIssueTimes" type="number" style="width: 250px">
                  <template slot="prepend">主播下发次数</template>
                  <template slot="append">次</template>
                </el-input>
                <el-input v-model="item.viewPageTriggerProbability" type="number" style="width: 300px">
                  <template slot="prepend">{{ formTrigger.strategyType == 4 ? '查看' : '关注' }}资料页触发概率</template>
                  <template slot="append">%</template>
                </el-input>
                <el-select v-model="item.autoMessageName" filterable clearable placeholder="请选择策略下发内容">
                  <el-option-group v-for="group in options" :key="group.label" :label="group.label">
                    <el-option v-for="item in group.options" :key="item.value" :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-option-group>
                </el-select>
                <el-input v-model="item.userReceptionTimes" type="number" style="width: 250px">
                  <template slot="prepend">用户接受次数</template>
                  <template slot="append">次</template>
                </el-input>
              </div>
              <el-button style="margin-top: 10px" @click="addMore(3)">+（添加更多策略内容）</el-button>
            </div>
          </el-row>
        </template>
        <template v-else-if="formTrigger.strategyType === 6">
          <el-row class="triggerItem">
            <div class="otherMessage">
              <div class="items" v-for="(item, index) in strategyType6List" :key="index">
                <div class="delete" @click="() => {
                  strategyType6List.splice(index, 1)
                }">X</div>
                <el-select v-model="item.hostSign" placeholder="请选择主播标签" filterable clearable>
                  <el-option v-for="(hostItem, hostIndex) in hostList" :key="hostIndex" :label="hostItem.name"
                    :value="hostItem.name"></el-option>
                </el-select>
                <el-input v-model="item.triggerProbability" type="number" style="width: 250px">
                  <template slot="prepend">触发概率</template>
                  <template slot="append">%</template>
                </el-input>
                <el-select v-model="item.autoMessageName" filterable clearable placeholder="请选择策略下发内容">
                  <el-option-group v-for="group in options" :key="group.label" :label="group.label">
                    <el-option v-for="optionItem in group.options" :key="optionItem.value" :label="optionItem.label"
                      :value="optionItem.value">
                    </el-option>
                  </el-option-group>
                </el-select>
                
                <!-- 主播下发次数限制配置 -->
                <div class="limitConfig">
                  <h4>主播下发次数限制</h4>
                  <el-select v-model="item.hostIssueTimesObject" placeholder="请选择维度" style="width: 150px">
                    <el-option label="全部用户" :value="1"></el-option>
                    <el-option label="单个用户" :value="2"></el-option>
                  </el-select>
                  <el-input v-model="item.hostIssueTimesTime" type="number" min="1" placeholder="请输入时间" style="width: 200px"
                    @blur="validateTimeFormat(item.hostIssueTimesTime, 'hostIssueTimesTime', index, 6)">
                    <template slot="append">小时</template>
                  </el-input>
                  <el-input v-model="item.hostIssueTimes" type="number" min="0" style="width: 250px">
                    <template slot="prepend">次数</template>
                    <template slot="append">次</template>
                  </el-input>
                </div>
                
                <!-- 用户接收次数限制配置 -->
                <div class="limitConfig">
                  <h4>用户接收次数限制</h4>
                  <el-select v-model="item.userReceptionTimesObject" placeholder="请选择维度" style="width: 150px">
                    <el-option label="全部主播" :value="1"></el-option>
                    <el-option label="单个主播" :value="2"></el-option>
                  </el-select>
                  <el-input v-model="item.userReceptionTimesTime" type="number" min="1" placeholder="请输入时间" style="width: 200px"
                    @blur="validateTimeFormat(item.userReceptionTimesTime, 'userReceptionTimesTime', index, 6)">
                    <template slot="append">小时</template>
                  </el-input>
                  <el-input v-model="item.userReceptionTimes" type="number" min="0" style="width: 250px">
                    <template slot="prepend">次数</template>
                    <template slot="append">次</template>
                  </el-input>
                </div>
              </div>
              <el-button style="margin-top: 10px" @click="addMore(4)">+（添加更多策略内容）</el-button>
            </div>
          </el-row>
        </template>
        <template v-else-if="formTrigger.strategyType === 7">
          <el-row class="triggerItem">
            <div class="otherMessage">
              <div class="items" v-for="(item, index) in strategyType7List" :key="index">
                <div class="delete" @click="() => {
                  strategyType7List.splice(index, 1)
                }">X</div>
                <el-select v-model="item.hostSign" placeholder="请选择主播标签" filterable clearable>
                  <el-option v-for="(hostItem, hostIndex) in hostList" :key="hostIndex" :label="hostItem.name"
                    :value="hostItem.name"></el-option>
                </el-select>
                
                <!-- 挂断触发概率 -->
                <el-input v-model="item.stopTriggerProbability" type="number" style="width: 250px">
                  <template slot="prepend">挂断触发概率</template>
                  <template slot="append">%</template>
                </el-input>
                
                <!-- 挂断策略内容 -->
                <el-select v-model="item.stopAutoMessageName" filterable clearable placeholder="请选择挂断策略内容">
                  <el-option-group v-for="group in options" :key="group.label" :label="group.label">
                    <el-option v-for="optionItem in group.options" :key="optionItem.value" :label="optionItem.label"
                      :value="optionItem.value">
                    </el-option>
                  </el-option-group>
                </el-select>
                
                <!-- 接听触发概率 -->
                <el-input v-model="item.startTriggerProbability" type="number" style="width: 250px">
                  <template slot="prepend">接听触发概率</template>
                  <template slot="append">%</template>
                </el-input>
                
                <!-- 接听策略内容 -->
                <el-select v-model="item.startAutoMessageName" filterable clearable placeholder="请选择接听策略内容">
                  <el-option-group v-for="group in options" :key="group.label" :label="group.label">
                    <el-option v-for="optionItem in group.options" :key="optionItem.value" :label="optionItem.label"
                      :value="optionItem.value">
                    </el-option>
                  </el-option-group>
                </el-select>
                
                <!-- 主播下发次数限制配置 -->
                <div class="limitConfig">
                  <h4>主播下发次数限制</h4>
                  <el-select v-model="item.hostIssueTimesObject" placeholder="请选择维度" style="width: 150px">
                    <el-option label="全部用户" :value="1"></el-option>
                    <el-option label="单个用户" :value="2"></el-option>
                  </el-select>
                  <el-input v-model="item.hostIssueTimesTime" type="number" min="1" placeholder="请输入时间" style="width: 200px"
                    @blur="validateTimeFormat(item.hostIssueTimesTime, 'hostIssueTimesTime', index, 7)">
                    <template slot="append">小时</template>
                  </el-input>
                  <el-input v-model="item.hostIssueTimes" type="number" min="0" style="width: 250px">
                    <template slot="prepend">次数</template>
                    <template slot="append">次</template>
                  </el-input>
                </div>
                
                <!-- 用户接收次数限制配置 -->
                <div class="limitConfig">
                  <h4>用户接收次数限制</h4>
                  <el-select v-model="item.userReceptionTimesObject" placeholder="请选择维度" style="width: 150px">
                    <el-option label="全部主播" :value="1"></el-option>
                    <el-option label="单个主播" :value="2"></el-option>
                  </el-select>
                  <el-input v-model="item.userReceptionTimesTime" type="number" min="1" placeholder="请输入时间" style="width: 200px"
                    @blur="validateTimeFormat(item.userReceptionTimesTime, 'userReceptionTimesTime', index, 7)">
                    <template slot="append">小时</template>
                  </el-input>
                  <el-input v-model="item.userReceptionTimes" type="number" min="0" style="width: 250px">
                    <template slot="prepend">次数</template>
                    <template slot="append">次</template>
                  </el-input>
                </div>
              </div>
              <el-button style="margin-top: 10px" @click="addMore(5)">+（添加更多策略内容）</el-button>
            </div>
          </el-row>
        </template>
        <template v-else-if="formTrigger.strategyType === 8">
          <el-row class="triggerItem">
            <div class="otherMessage">
              <div class="items" v-for="(item, index) in strategyType8List" :key="index">
                <div class="delete" @click="() => {
                  strategyType8List.splice(index, 1)
                }">X</div>
                <el-select v-model="item.hostSign" placeholder="请选择主播标签" filterable clearable>
                  <el-option v-for="(hostItem, hostIndex) in hostList" :key="hostIndex" :label="hostItem.name"
                    :value="hostItem.name"></el-option>
                </el-select>
                <el-input v-model="item.intervalTime" type="number" min="1" style="width: 250px">
                  <template slot="prepend">充值间隔时间</template>
                  <template slot="append">分钟</template>
                </el-input>
                <el-input v-model="item.triggerProbability" type="number" style="width: 250px">
                  <template slot="prepend">触发概率</template>
                  <template slot="append">%</template>
                </el-input>
                <el-select v-model="item.autoMessageName" filterable clearable placeholder="请选择策略下发内容">
                  <el-option-group v-for="group in options" :key="group.label" :label="group.label">
                    <el-option v-for="optionItem in group.options" :key="optionItem.value" :label="optionItem.label"
                      :value="optionItem.value">
                    </el-option>
                  </el-option-group>
                </el-select>
                
                <!-- 主播下发次数限制配置 -->
                <div class="limitConfig">
                  <h4>主播下发次数限制</h4>
                  <el-select v-model="item.hostIssueTimesObject" placeholder="请选择维度" style="width: 150px">
                    <el-option label="全部用户" :value="1"></el-option>
                    <el-option label="单个用户" :value="2"></el-option>
                  </el-select>
                  <el-input v-model="item.hostIssueTimesTime" type="number" min="1" placeholder="请输入时间" style="width: 200px"
                    @blur="validateTimeFormat(item.hostIssueTimesTime, 'hostIssueTimesTime', index, 8)">
                    <template slot="append">小时</template>
                  </el-input>
                  <el-input v-model="item.hostIssueTimes" type="number" min="0" style="width: 250px">
                    <template slot="prepend">次数</template>
                    <template slot="append">次</template>
                  </el-input>
                </div>
                
                <!-- 用户接收次数限制配置 -->
                <div class="limitConfig">
                  <h4>用户接收次数限制</h4>
                  <el-select v-model="item.userReceptionTimesObject" placeholder="请选择维度" style="width: 150px">
                    <el-option label="全部主播" :value="1"></el-option>
                    <el-option label="单个主播" :value="2"></el-option>
                  </el-select>
                  <el-input v-model="item.userReceptionTimesTime" type="number" min="1" placeholder="请输入时间" style="width: 200px"
                    @blur="validateTimeFormat(item.userReceptionTimesTime, 'userReceptionTimesTime', index, 8)">
                    <template slot="append">小时</template>
                  </el-input>
                  <el-input v-model="item.userReceptionTimes" type="number" min="0" style="width: 250px">
                    <template slot="prepend">次数</template>
                    <template slot="append">次</template>
                  </el-input>
                </div>
              </div>
              <el-button style="margin-top: 10px" @click="addMore(6)">+（添加更多策略内容）</el-button>
            </div>
          </el-row>
        </template>
        <template v-else-if="formTrigger.strategyType === 9">
          <el-row class="triggerItem">
            <div class="otherMessage">
              <div class="items" v-for="(item, index) in strategyType9List" :key="index">
                <div class="delete" @click="() => {
                  strategyType9List.splice(index, 1)
                }">X</div>
                <el-select v-model="item.hostSign" placeholder="请选择主播标签" filterable clearable>
                  <el-option v-for="(hostItem, hostIndex) in hostList" :key="hostIndex" :label="hostItem.name"
                    :value="hostItem.name"></el-option>
                </el-select>
                <el-input v-model="item.intervalTime" type="number" min="1" style="width: 250px">
                  <template slot="prepend">充值间隔时间</template>
                  <template slot="append">分钟</template>
                </el-input>
                <el-input v-model="item.triggerProbability" type="number" style="width: 250px">
                  <template slot="prepend">触发概率</template>
                  <template slot="append">%</template>
                </el-input>
                <el-select v-model="item.autoMessageName" filterable clearable placeholder="请选择策略下发内容">
                  <el-option-group v-for="group in options" :key="group.label" :label="group.label">
                    <el-option v-for="optionItem in group.options" :key="optionItem.value" :label="optionItem.label"
                      :value="optionItem.value">
                    </el-option>
                  </el-option-group>
                </el-select>
                
                <!-- 主播下发次数限制配置 -->
                <div class="limitConfig">
                  <h4>主播下发次数限制</h4>
                  <el-select v-model="item.hostIssueTimesObject" placeholder="请选择维度" style="width: 150px">
                    <el-option label="全部用户" :value="1"></el-option>
                    <el-option label="单个用户" :value="2"></el-option>
                  </el-select>
                  <el-input v-model="item.hostIssueTimesTime" type="number" min="1" placeholder="请输入时间" style="width: 200px"
                    @blur="validateTimeFormat(item.hostIssueTimesTime, 'hostIssueTimesTime', index, 9)">
                    <template slot="append">小时</template>
                  </el-input>
                  <el-input v-model="item.hostIssueTimes" type="number" min="0" style="width: 250px">
                    <template slot="prepend">次数</template>
                    <template slot="append">次</template>
                  </el-input>
                </div>
                
                <!-- 用户接收次数限制配置 -->
                <div class="limitConfig">
                  <h4>用户接收次数限制</h4>
                  <el-select v-model="item.userReceptionTimesObject" placeholder="请选择维度" style="width: 150px">
                    <el-option label="全部主播" :value="1"></el-option>
                    <el-option label="单个主播" :value="2"></el-option>
                  </el-select>
                  <el-input v-model="item.userReceptionTimesTime" type="number" min="1" placeholder="请输入时间" style="width: 200px"
                    @blur="validateTimeFormat(item.userReceptionTimesTime, 'userReceptionTimesTime', index, 9)">
                    <template slot="append">小时</template>
                  </el-input>
                  <el-input v-model="item.userReceptionTimes" type="number" min="0" style="width: 250px">
                    <template slot="prepend">次数</template>
                    <template slot="append">次</template>
                  </el-input>
                </div>
              </div>
              <el-button style="margin-top: 10px" @click="addMore(7)">+（添加更多策略内容）</el-button>
            </div>
          </el-row>
        </template>
        <el-form-item>
          <el-button @click="resetForm('Form', 1)">取消</el-button>
          <el-button type="primary" @click="submitTrigger('Form')">立即创建</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { matchRuleReq } from '@/api/matchConfigApi'

export default {
  name: 'StrategySystem',
  components: {
    draggable,
  },
  props: {
    strategyTypeList: {
      type: Array,
      default: () => []
    },
    channelList: {
      type: Array,
      default: () => []
    },
    countryList: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      total: 0,
      lastPage: 10,
      currentPage: 1,
      triggerDialog: false,
      triggerType: 0,
      reviewDialog: false,
      review: {
        userRid: null,
        hostRid: null,
        strategyType: null,
        triggerName: '',
        debug: true,
      },
      reviewList: {
        log: '',
        signList: [],
      },
      otherList: [
        {
          hostSign: '',
          viewPageSecond: 0,
          autoMessageName: null,
          hostIssueTimes: 0,
          userReceptionTimes: 0
        }
      ],
      rules: {
        name: { required: true, message: '请输入策略名称', trigger: 'blur' },
        channel: { required: true, message: '请选择渠道', trigger: 'change' },
        strategyType: {
          required: true,
          message: '请选择策略类型',
          trigger: 'change',
        },
        lang: { required: true, message: '请选择语言', trigger: 'change' },
      },
      mathAllList: [],
      loginList: {
        day: 1,
        items: [],
      },
      vipList: {
        day: 1,
        items: [],
      },
      matchingList: {
        mutualFollowRate: {},
        singleFollowRate: {},
        noFollowRate: {},
      },
      searchListTrigger: {
        strategyType: '',
        countryCode: null,
        channel: '',
      },
      formTrigger: {
        name: '',
        strategyType: null,
        remark: '',
        isChannel: false,
        isCountry: false,
        countryCode: null,
      },
      hostSignlist: [],
      messageListTrigger: [],
      triggerMessage: [],
      triggerTotalPage: 10,
      triggerCurrentPage: 0,
      pageSize: 30,
      userList: [],
      hostList: [],
      strategyType6List: [
        {
          hostSign: '',
          triggerProbability: '',
          autoMessageName: null,
          hostIssueTimes: 0,
          hostIssueTimesObject: 1,
          hostIssueTimesTime: '',
          userReceptionTimes: 0,
          userReceptionTimesObject: 1,
          userReceptionTimesTime: '',
        }
      ],
      strategyType7List: [
        {
          hostSign: '',
          stopTriggerProbability: '',
          stopAutoMessageName: null,
          startTriggerProbability: '',
          startAutoMessageName: null,
          hostIssueTimes: 0,
          hostIssueTimesObject: 1,
          hostIssueTimesTime: '',
          userReceptionTimes: 0,
          userReceptionTimesObject: 1,
          userReceptionTimesTime: '',
        }
      ],
      strategyType8List: [
        {
          hostSign: '',
          intervalTime: 0,
          triggerProbability: '',
          autoMessageName: null,
          hostIssueTimes: 0,
          hostIssueTimesObject: 1,
          hostIssueTimesTime: '',
          userReceptionTimes: 0,
          userReceptionTimesObject: 1,
          userReceptionTimesTime: '',
        }
      ],
      strategyType9List: [
        {
          hostSign: '',
          intervalTime: 0,
          triggerProbability: '',
          autoMessageName: null,
          hostIssueTimes: 0,
          hostIssueTimesObject: 1,
          hostIssueTimesTime: '',
          userReceptionTimes: 0,
          userReceptionTimesObject: 1,
          userReceptionTimesTime: '',
        }
      ],
    }
  },
  mounted() {
    this.getAllMessageTrigger(0)
    this.mathAll()
  },
  watch: {
    'formTrigger.strategyType': {
      handler(newVal) {
        if (newVal == 4 || newVal == 5 || newVal == 6 || newVal == 7 || newVal == 8 || newVal == 9) {
          this.getNewUserSigns(0)
          this.getNewUserSigns(1)
        } else {
          this.getUserSigns()
        }
      },
    },
  },
  methods: {
    async getNewUserSigns(type = 0) {
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.config_userSign_query,
        data: {
          data: {
            signType: 'auto_message',
            signTemplate: type == 0 ? 'user' : 'host',
          },
          page: 0,
        },
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        if (type == 0) {
          this.userList = res.data.list
        } else {
          this.hostList = res.data.list
        }
      }
    },
    async mathAll() {
      const res = await matchRuleReq({
        ruleName: '',
        valid: null,
        page: -1,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.mathAllList = res.data.matchRuleConfigBOList.map(
          (item) => item.ruleName
        )
      }
    },
    async getUserSigns() {
      if (this.currentPage > this.lastPage) {
        return
      }
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.config_userSign_query,
        data: {
          data: {
            signTemplate: 'host',
            signType: 'auto_message',
          },
          page: this.currentPage,
        },
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        if (this.currentPage === 1) {
          this.hostSignlist = res.data.list
        } else {
          this.hostSignlist = [...this.hostSignlist, ...res.data.list]
        }
        this.currentPage++
        this.total = res.data.total
        this.lastPage = Math.ceil(this.total / 30)
      }
    },
    async reviewQuery() {
      if (this.review.userRid && this.review.strategyType) {
        const { data: res } = await this.$axios({
          method: 'POST',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
          },
          url: this.$store.getters.path.config_autoMessage_review,
          data: this.review,
          params: {
            username: this.$store.getters.username,
            token: this.$store.getters.token,
          },
        })

        if (res.code != 0) {
          return this.$message.error(res.msg)
        } else {
          this.reviewDialog = true
          this.reviewList = res.data
        }
      } else {
        return this.$message.warning('rid或策略不能为空')
      }
    },
    getName(key, arr) {
      let name = ''
      arr.forEach((item) => {
        if (item.value == key) {
          name = item.name
          return
        }
      })
      return name
    },
    async getAllMessageTrigger(page) {
      this.triggerCurrentPage = page
      let info = {
        data: this.searchListTrigger,
        page: page,
      }
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json;  charset=UTF-8',
        },
        url: this.$store.getters.path.config_autoMessage_queryTriggers,
        data: info,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })
      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.triggerTotalPage = res.data.total
        this.messageListTrigger = res.data.list
      }
    },
    async deleteTriggerMessage(id) {
      this.$confirm('删除后已生效的配置将失效，确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          if (!id) return this.$message.warning('用户id不存在')
          const { data: res } = await this.$axios({
            method: 'POST',
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json;',
            },
            url: this.$store.getters.path.config_autoMessage_deleteTriggers,
            data: {
              id: id,
            },
            params: {
              username: this.$store.getters.username,
              token: this.$store.getters.token,
            },
          })

          if (res.code != 0) {
            return this.$message.error(res.msg)
          } else {
            this.$message.success('删除成功')
            this.getAllMessageTrigger()
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    changeTrigger(data) {
      const messageInfo = JSON.parse(JSON.stringify(data))
      messageInfo.valid = Math.abs(data.valid - 1)
      this.undateTriggerData(messageInfo)
    },
    guaranteedHandleCurrentChangeTrigger(page) {
      this.getAllMessageTrigger(page)
    },
    async updateTriggerMessage(data, type) {
      if (type === 0) {
        this.triggerType = 0
      } else {
        let info = JSON.parse(JSON.stringify(data))
        info.channel = info.channel.split(',')
        info.countryCode = info.countryCode.split(',')
        info.isCountry = false
        info.isChannel = false
        if (
          info.countryCode.length > 0 &&
          info.countryCode[0].charAt(0) == '-'
        ) {
          info.isCountry = true
          info.countryCode[0] = info.countryCode[0].substring(1)
        }
        if (info.channel.length > 0 && info.channel[0].charAt(0) == '-') {
          info.isChannel = true
          info.channel[0] = info.channel[0].substring(1)
        }
        if (type === 1) {
          this.triggerType = 1
        } else {
          this.triggerType = 2
          info.id = ''
          info.name = ''
        }
        this.formTrigger.userSign = []
        if (info.userSign) {
          info.userSign = JSON.parse(info.userSign)
        }
        this.formTrigger = info
        let message = JSON.parse(info.triggerJson)
        if (info.strategyType === 1) {
          this.loginList = message
        } else if (info.strategyType === 2) {
          this.vipList = message
        } else if (info.strategyType === 3) {
          this.matchingList = message
        } else if (info.strategyType === 4 || info.strategyType === 5) {
          this.otherList = message
        } else if (info.strategyType === 6) {
          this.strategyType6List = message
          // 确保时间字段是数字类型
          this.strategyType6List.forEach(item => {
            if (typeof item.hostIssueTimesTime !== 'number') {
              item.hostIssueTimesTime = parseInt(item.hostIssueTimesTime) || 0
            }
            if (typeof item.userReceptionTimesTime !== 'number') {
              item.userReceptionTimesTime = parseInt(item.userReceptionTimesTime) || 0
            }
          })
        } else if (info.strategyType === 7) {
          this.strategyType7List = message
          // 确保时间字段是数字类型
          this.strategyType7List.forEach(item => {
            if (typeof item.hostIssueTimesTime !== 'number') {
              item.hostIssueTimesTime = parseInt(item.hostIssueTimesTime) || 0
            }
            if (typeof item.userReceptionTimesTime !== 'number') {
              item.userReceptionTimesTime = parseInt(item.userReceptionTimesTime) || 0
            }
            // 确保概率字段是数字类型
            if (typeof item.stopTriggerProbability !== 'number') {
              item.stopTriggerProbability = parseInt(item.stopTriggerProbability) || 0
            }
            if (typeof item.startTriggerProbability !== 'number') {
              item.startTriggerProbability = parseInt(item.startTriggerProbability) || 0
            }
          })
        } else if (info.strategyType === 8) {
          this.strategyType8List = message
          // 确保时间字段是数字类型
          this.strategyType8List.forEach(item => {
            if (typeof item.hostIssueTimesTime !== 'number') {
              item.hostIssueTimesTime = parseInt(item.hostIssueTimesTime) || 0
            }
            if (typeof item.userReceptionTimesTime !== 'number') {
              item.userReceptionTimesTime = parseInt(item.userReceptionTimesTime) || 0
            }
            if (typeof item.intervalTime !== 'number') {
              item.intervalTime = parseInt(item.intervalTime) || 0
            }
          })
        } else if (info.strategyType === 9) {
          this.strategyType9List = message
          // 确保时间字段是数字类型
          this.strategyType9List.forEach(item => {
            if (typeof item.hostIssueTimesTime !== 'number') {
              item.hostIssueTimesTime = parseInt(item.hostIssueTimesTime) || 0
            }
            if (typeof item.userReceptionTimesTime !== 'number') {
              item.userReceptionTimesTime = parseInt(item.userReceptionTimesTime) || 0
            }
            if (typeof item.intervalTime !== 'number') {
              item.intervalTime = parseInt(item.intervalTime) || 0
            }
          })
        }
      }
      this.triggerDialog = true
    },
    submitTrigger(formName) {
      this.$refs[formName].validate((valid) => {
        const { channel, countryCode, userSign } = this.formTrigger;
        this.formTrigger.channel = Array.isArray(channel) && channel.length ? channel.join(',') : null;
        this.formTrigger.countryCode = Array.isArray(countryCode) && countryCode.length ? countryCode.join(',') : null;
        this.formTrigger.userSign = Array.isArray(userSign) && userSign.length ? JSON.stringify(userSign) : null;
        if (valid) {
          let info = null
          if (
            this.formTrigger.strategyType == 1 &&
            this.loginList.items.length > 0
          ) {
            this.loginList.items.forEach((item, index) => {
              item.index = index
            })
            info = JSON.stringify(this.loginList)
          } else if (
            this.formTrigger.strategyType == 2 &&
            this.vipList.items.length > 0
          ) {
            this.vipList.items.forEach((item, index) => {
              item.index = index
            })
            info = JSON.stringify(this.vipList)
          } else if (this.formTrigger.strategyType == 3) {
            let newObj = {}
            for (const key in this.matchingList) {
              if (
                this.matchingList[key].rate &&
                this.matchingList[key].autoMessageName
              ) {
                newObj[key] = this.matchingList[key]
              } else {
                newObj[key] = {}
              }
            }
            info = JSON.stringify(newObj)
          } else if (this.formTrigger.strategyType == 4 || this.formTrigger.strategyType == 5) {
            if (this.formTrigger.strategyType == 5) {
              delete this.otherList.viewPageSecond
            }
            info = JSON.stringify(this.otherList)
          } else if (this.formTrigger.strategyType === 6) {
            
            // 验证每个配置项并转换数据类型
            for (let i = 0; i < this.strategyType6List.length; i++) {
              const item = this.strategyType6List[i]
              // 确保数值类型为int
              item.hostIssueTimes = parseInt(item.hostIssueTimes) || 0
              item.userReceptionTimes = parseInt(item.userReceptionTimes) || 0
              item.hostIssueTimesObject = parseInt(item.hostIssueTimesObject) || 1
              item.userReceptionTimesObject = parseInt(item.userReceptionTimesObject) || 1
              item.hostIssueTimesTime = parseInt(item.hostIssueTimesTime) || 0
              item.userReceptionTimesTime = parseInt(item.userReceptionTimesTime) || 0
            }
            info = JSON.stringify(this.strategyType6List)
          } else if (this.formTrigger.strategyType === 7) {
            
            // 验证每个配置项并转换数据类型
            for (let i = 0; i < this.strategyType7List.length; i++) {
              const item = this.strategyType7List[i]
              
              // 确保数值类型为int
              item.hostIssueTimes = parseInt(item.hostIssueTimes) || 0
              item.userReceptionTimes = parseInt(item.userReceptionTimes) || 0
              item.hostIssueTimesObject = parseInt(item.hostIssueTimesObject) || 1
              item.userReceptionTimesObject = parseInt(item.userReceptionTimesObject) || 1
              item.hostIssueTimesTime = parseInt(item.hostIssueTimesTime) || 0
              item.userReceptionTimesTime = parseInt(item.userReceptionTimesTime) || 0
            }
            info = JSON.stringify(this.strategyType7List)
          } else if (this.formTrigger.strategyType === 8) {
            
            // 验证每个配置项并转换数据类型
            for (let i = 0; i < this.strategyType8List.length; i++) {
              const item = this.strategyType8List[i]
              
              // 确保数值类型为int
              item.hostIssueTimes = parseInt(item.hostIssueTimes) || 0
              item.userReceptionTimes = parseInt(item.userReceptionTimes) || 0
              item.hostIssueTimesObject = parseInt(item.hostIssueTimesObject) || 1
              item.userReceptionTimesObject = parseInt(item.userReceptionTimesObject) || 1
              item.hostIssueTimesTime = parseInt(item.hostIssueTimesTime) || 0
              item.userReceptionTimesTime = parseInt(item.userReceptionTimesTime) || 0
              item.intervalTime = parseInt(item.intervalTime) || 0
            }
            info = JSON.stringify(this.strategyType8List)
          } else if (this.formTrigger.strategyType === 9) {
            
            // 验证每个配置项并转换数据类型
            for (let i = 0; i < this.strategyType9List.length; i++) {
              const item = this.strategyType9List[i]
              
              // 确保数值类型为int
              item.hostIssueTimes = parseInt(item.hostIssueTimes) || 0
              item.userReceptionTimes = parseInt(item.userReceptionTimes) || 0
              item.hostIssueTimesObject = parseInt(item.hostIssueTimesObject) || 1
              item.userReceptionTimesObject = parseInt(item.userReceptionTimesObject) || 1
              item.hostIssueTimesTime = parseInt(item.hostIssueTimesTime) || 0
              item.userReceptionTimesTime = parseInt(item.userReceptionTimesTime) || 0
              item.intervalTime = parseInt(item.intervalTime) || 0
            }
            info = JSON.stringify(this.strategyType9List)
          }
          const messageInfo = { ...this.formTrigger, triggerJson: info }
          this.undateTriggerData(messageInfo)
        } else {
          return false
        }
      })
    },
    async undateTriggerData(data) {
      let messageInfo = {
        data: JSON.parse(JSON.stringify(data)),
      }
      if (this.formTrigger.isChannel) {
        messageInfo.data.channel = '-' + messageInfo.data.channel
      }
      if (this.formTrigger.isCountry) {
        messageInfo.data.countryCode = '-' + messageInfo.data.countryCode
      }
      const { data: res } = await this.$axios({
        method: 'POST',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
        },
        url: this.$store.getters.path.config_autoMessage_updateTrigger,
        data: messageInfo,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
        },
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.$message.success('修改成功')
        this.resetForm('Form', 1)
        this.getAllMessageTrigger(this.triggerCurrentPage)
      }
    },
    addMore(status) {
      if (status === 1) {
        this.loginList.items = this.loginList.items ? this.loginList.items : []
        this.loginList.items.push({})
      } else if (status === 2) {
        this.vipList.items = this.vipList.items ? this.vipList.items : []
        this.vipList.items.push({})
      } else if (status === 3) {
        this.otherList.push({})
      } else if (status === 4) {
        this.strategyType6List.push({
          hostSign: '',
          triggerProbability: '',
          autoMessageName: null,
          hostIssueTimes: 0,
          hostIssueTimesObject: 1,
          hostIssueTimesTime: '',
          userReceptionTimes: 0,
          userReceptionTimesObject: 1,
          userReceptionTimesTime: '',
        })
      } else if (status === 5) {
        this.strategyType7List.push({
          hostSign: '',
          stopTriggerProbability: '',
          stopAutoMessageName: null,
          startTriggerProbability: '',
          startAutoMessageName: null,
          hostIssueTimes: 0,
          hostIssueTimesObject: 1,
          hostIssueTimesTime: '',
          userReceptionTimes: 0,
          userReceptionTimesObject: 1,
          userReceptionTimesTime: '',
        })
      } else if (status === 6) {
        this.strategyType8List.push({
          hostSign: '',
          intervalTime: 0,
          triggerProbability: '',
          autoMessageName: null,
          hostIssueTimes: 0,
          hostIssueTimesObject: 1,
          hostIssueTimesTime: '',
          userReceptionTimes: 0,
          userReceptionTimesObject: 1,
          userReceptionTimesTime: '',
        })
      } else if (status === 7) {
        this.strategyType9List.push({
          hostSign: '',
          intervalTime: 0,
          triggerProbability: '',
          autoMessageName: null,
          hostIssueTimes: 0,
          hostIssueTimesObject: 1,
          hostIssueTimesTime: '',
          userReceptionTimes: 0,
          userReceptionTimesObject: 1,
          userReceptionTimesTime: '',
        })
      }
    },
    async closeTrigger(index, status) {
      this.$confirm('是否删除该节点?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        this.$message.success('节点删除成功')
        if (status === 1) {
          this.loginList.items.splice(index, 1)
        } else if (status === 2) {
          this.vipList.items.splice(index, 1)
        } else if (status === 3) {
          this.otherList.splice(index, 1)
        } else if (status === 4) {
          this.strategyType6List.splice(index, 1)
        } else if (status === 5) {
          this.strategyType7List.splice(index, 1)
        } else if (status === 6) {
          this.strategyType8List.splice(index, 1)
        } else if (status === 7) {
          this.strategyType9List.splice(index, 1)
        }
      })
    },
    loadMoreUserSigns() {
      this.getUserSigns()
    },
    resetForm(formName, status) {
      if (status === 1) {
        Object.keys(this.formTrigger).forEach(
          (key) => (this.formTrigger[key] = '')
        )
        this.formTrigger.isChannel = false
        this.formTrigger.isCountry = false
        this.loginList = { day: 1, items: [] }
        this.vipList = { day: 1, items: [] }
        this.matchingList = {
          mutualFollowRate: {},
          singleFollowRate: {},
          noFollowRate: {},
        }
        this.otherList = [
          {
            hostSign: '',
            viewPageSecond: 0,
            autoMessageName: null,
            hostIssueTimes: 0,
            userReceptionTimes: 0
          }
        ]
        this.strategyType6List = [
          {
            hostSign: '',
            triggerProbability: '',
            autoMessageName: null,
            hostIssueTimes: 0,
            hostIssueTimesObject: 1,
            hostIssueTimesTime: '',
            userReceptionTimes: 0,
            userReceptionTimesObject: 1,
            userReceptionTimesTime: '',
          }
        ]
        this.strategyType7List = [
          {
            hostSign: '',
            stopTriggerProbability: '',
            stopAutoMessageName: null,
            startTriggerProbability: '',
            startAutoMessageName: null,
            hostIssueTimes: 0,
            hostIssueTimesObject: 1,
            hostIssueTimesTime: '',
            userReceptionTimes: 0,
            userReceptionTimesObject: 1,
            userReceptionTimesTime: '',
          }
        ]
        this.strategyType8List = [
          {
            hostSign: '',
            intervalTime: 0,
            triggerProbability: '',
            autoMessageName: null,
            hostIssueTimes: 0,
            hostIssueTimesObject: 1,
            hostIssueTimesTime: '',
            userReceptionTimes: 0,
            userReceptionTimesObject: 1,
            userReceptionTimesTime: '',
          }
        ]
        this.strategyType9List = [
          {
            hostSign: '',
            intervalTime: 0,
            triggerProbability: '',
            autoMessageName: null,
            hostIssueTimes: 0,
            hostIssueTimesObject: 1,
            hostIssueTimesTime: '',
            userReceptionTimes: 0,
            userReceptionTimesObject: 1,
            userReceptionTimesTime: '',
          }
        ]
        this.triggerDialog = false
      }
    },
    validateTimeFormat(value, field, index, strategyType) {
      if (!value) return true
      
      // 验证是否为正整数
      const number = parseInt(value)
      if (isNaN(number) || number <= 0) {
        this.$message.error('时间必须为正整数')
        return false
      }
      
      // 检查是否超过7天（168小时）
      // if (number > 168) {
      //   this.$message.error('时间不能超过7天（168小时）')
      //   return false
      // }
      
      return true
    },
  }, 
  directives: {
    'el-select-loadmore': (el, binding) => {
      const SELECTWRAP_DOM = el.querySelector(
        '.el-select-dropdown .el-select-dropdown__wrap'
      )
      if (SELECTWRAP_DOM) {
        SELECTWRAP_DOM.addEventListener('scroll', function () {
          const condition =
            this.scrollHeight - this.scrollTop <= this.clientHeight
          if (condition) binding.value()
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.auto-message {
  &__search {
    span {
      font-size: 20px;
      font-weight: 600;
      margin-right: 15px;
      margin-left: 15px;
    }
  }
}

.triggerItem {
  border: 1px solid #000;
  border-radius: 10px;
  padding: 10px;

  .day {
    .title {
      margin-right: 10px;
    }
  }

  .contentItem {
    display: flex;
    border: 1px solid #000;
    padding: 10px;
    border-radius: 10px;
    align-items: center;
    gap: 30px;
    cursor: pointer;
    position: relative;
    margin-bottom: 15px;

    span {
      font-size: 20px;
      font-weight: bold;
    }

    .close {
      height: 25px;
      width: 25px;
      border-radius: 50%;
      border: 1px solid red;
      line-height: 25px;
      text-align: center;
      position: absolute;
      top: -10px;
      right: -10px;
    }
  }

  .otherMessage {
    .items {
      width: 100%;
      height: max-content;
      gap: 10px 50px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      border: 1px dashed #000;
      padding: 10px;
      margin-bottom: 10px;
      position: relative;

      .delete {
        height: 20px;
        width: 20px;
        border: 1px solid red;
        border-radius: 50%;
        text-align: center;
        line-height: 20px;
        font-size: 15px;
        cursor: pointer;
        position: absolute;
        top: -10px;
        right: -10px;
      }

      .limitConfig {
        width: 100%;
        border: 1px solid #e4e7ed;
        border-radius: 8px;
        padding: 15px;
        margin-top: 15px;
        background-color: #f8f9fa;

        h4 {
          margin: 0 0 10px 0;
          color: #303133;
          font-size: 14px;
          font-weight: 600;
        }

        .el-select,
        .el-input {
          margin-right: 10px;
          margin-bottom: 10px;
        }
      }
    }
  }
}

.reviewDialog {
  font-size: 25px;

  .head {
    margin-bottom: 20px;
    display: flex;

    p {
      padding: 10px;
      border: 1px solid #000;
      margin-right: 10px;
      background-color: transparent;
      cursor: auto;
    }
  }

  .content {
    white-space: pre-line;
  }
}
</style>
